import { Link } from "react-router-dom";
import { Instagram, Twitter, Linkedin, Facebook, Youtube, MessageCircle } from "lucide-react";

const SOCIALS = [
  { Icon: Instagram, label: "Instagram", url: "https://instagram.com/JoinDealVest", testid: "social-instagram" },
  { Icon: Twitter, label: "X (Twitter)", url: "https://x.com/JoinDealVest", testid: "social-x" },
  { Icon: Linkedin, label: "LinkedIn", url: "https://linkedin.com/company/JoinDealVest", testid: "social-linkedin-footer" },
  { Icon: Facebook, label: "Facebook", url: "https://facebook.com/JoinDealVest", testid: "social-facebook" },
  { Icon: Youtube, label: "YouTube", url: "https://youtube.com/@JoinDealVest", testid: "social-youtube" },
  { Icon: ({ size }) => (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor"><path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/></svg>
    ), label: "TikTok", url: "https://tiktok.com/@JoinDealVest", testid: "social-tiktok" },
];

export default function Footer() {
  return (
    <footer className="border-t border-slate-100 bg-slate-50 mt-24" data-testid="site-footer">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-8 py-14">
        <div className="grid lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-blue-500 to-blue-700 flex items-center justify-center text-white font-bold text-lg">D</div>
              <span className="font-bold text-xl">DealVest</span>
            </div>
            <p className="text-slate-600 text-[15px] max-w-md leading-relaxed mb-5">
              The simplest way to buy a business, sell yours, raise capital and find investors across Africa and the Middle East.
            </p>
            <div className="flex gap-2 flex-wrap">
              {SOCIALS.map(({ Icon, label, url, testid }) => (
                <a key={label} href={url} target="_blank" rel="noopener noreferrer" data-testid={testid} aria-label={label}
                  className="w-10 h-10 rounded-full bg-white border border-slate-200 hover:border-blue-500 hover:text-blue-600 flex items-center justify-center text-slate-500 transition-colors">
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>
          <div>
            <h4 className="font-semibold text-slate-900 mb-3 text-sm">Product</h4>
            <ul className="space-y-2.5 text-[15px]">
              <li><Link to="/marketplace" className="text-slate-600 hover:text-blue-600">Marketplace</Link></li>
              <li><Link to="/valuation" className="text-slate-600 hover:text-blue-600">Free Valuation</Link></li>
              <li><Link to="/idea-evaluator" className="text-slate-600 hover:text-blue-600">Idea Evaluator</Link></li>
              <li><Link to="/matches" className="text-slate-600 hover:text-blue-600">My Matches</Link></li>
              <li><Link to="/ai-tools" className="text-slate-600 hover:text-blue-600">AI Tools</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-slate-900 mb-3 text-sm">Company</h4>
            <ul className="space-y-2.5 text-[15px]">
              <li><Link to="/founder" className="text-slate-600 hover:text-blue-600">Founder's Story</Link></li>
              <li><Link to="/about" className="text-slate-600 hover:text-blue-600">About</Link></li>
              <li><Link to="/services" className="text-slate-600 hover:text-blue-600">Services</Link></li>
              <li><Link to="/blog" className="text-slate-600 hover:text-blue-600">Insights</Link></li>
              <li><Link to="/contact" className="text-slate-600 hover:text-blue-600">Contact</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-slate-900 mb-3 text-sm">Get Started</h4>
            <ul className="space-y-2.5 text-[15px]">
              <li><Link to="/signup" className="text-slate-600 hover:text-blue-600">Sign up</Link></li>
              <li><Link to="/login" className="text-slate-600 hover:text-blue-600">Log in</Link></li>
              <li><Link to="/whatsapp" className="text-slate-600 hover:text-blue-600 inline-flex items-center gap-1.5"><MessageCircle size={14} className="text-emerald-500" /> WhatsApp</Link></li>
              <li><Link to="/faq" className="text-slate-600 hover:text-blue-600">FAQ</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-slate-200 flex flex-col md:flex-row justify-between gap-3 text-sm text-slate-500">
          <span>© {new Date().getFullYear()} DealVest. All rights reserved.</span>
          <span>UAE · KSA · Qatar · Bahrain · Oman · Kuwait · Nigeria · Ghana · Kenya · South Africa · Egypt</span>
        </div>
      </div>
    </footer>
  );
}
